export const THUMBNAIL_SIZE = 50;
